import { Box, Grid2, Typography } from "@mui/material";
import { ReactNode } from "react";

interface DataGridItemHorizontalProps {
  label: ReactNode;
  children?: ReactNode | string;
  size?: number;
}

export function DataGridItemHorizontal({
  label,
  size = 12,
  children,
}: DataGridItemHorizontalProps) {
  const isString = typeof children === "string";

  return (
    <Grid2 size={size}>
      <Typography color="text.secondary" variant="subtitle2" mb={0.5}>
        {label}
      </Typography>
      {isString ? (
        <Box my={"6px"}>
          <Typography
            sx={{
              whiteSpace: "pre-wrap",
            }}
          >
            {children}
          </Typography>
        </Box>
      ) : (
        children
      )}
    </Grid2>
  );
}
